import { Locale, useLocale } from "../lib/i18n";

const labels: Record<Locale, string> = {
  ro: "RO",
  ru: "RU",
};

export function LanguageSwitcher() {
  const { locale, setLocale } = useLocale();

  return (
    <div className="inline-flex rounded-full bg-gray-100 p-1">
      {(["ro", "ru"] as const).map((item) => {
        const isActive = item === locale;
        return (
          <button
            key={item}
            type="button"
            onClick={() => setLocale(item)}
            className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
              isActive ? "bg-white text-gray-900 shadow-sm" : "text-gray-500"
            }`}
          >
            {labels[item]}
          </button>
        );
      })}
    </div>
  );
}
